import { cn } from "@/lib/cn";

export type Status =
  | "running"
  | "succeeded"
  | "queued"
  | "failed"
  | "active"
  | "archived"
  | "discarded"
  | "ready"
  | "profiling"
  | "revoked"
  | "draft";

const colorFor: Record<Status, string> = {
  running:
    "bg-info shadow-[0_0_0_3px_color-mix(in_srgb,var(--color-info)_15%,transparent)] animate-pulse",
  succeeded: "bg-success",
  queued: "bg-fg-dim",
  failed: "bg-danger",
  active: "bg-accent shadow-[0_0_0_3px_color-mix(in_srgb,var(--color-accent)_15%,transparent)]",
  archived: "bg-fg-dim",
  discarded: "bg-danger",
  ready: "bg-success",
  profiling: "bg-info animate-pulse",
  revoked: "bg-fg-dim",
  draft: "bg-warning",
};

export function StatusDot({
  status,
  label,
  className,
}: { status: Status; label?: string; className?: string }) {
  return (
    <span className={cn("inline-flex items-center gap-2 text-xs", className)}>
      <span className={cn("size-[7px] flex-none rounded-full", colorFor[status])} />
      {label ?? status}
    </span>
  );
}
